import { OfferFragment } from '@occc/graphql';
import { makeCreateInStoreOnlyConstraintOperation } from '@occc-app/offerHelpers/operations/constraints';
import { makeDeleteOperation } from '@occc-app/offerHelpers/operations/makeDeleteOperation';
import { DirtyFieldsType, Operation } from '@occc-app/offerHelpers/types';
import { isFieldDirty } from '@occc-app/offerHelpers/utils';
import { constraintHelper } from '@occc-app/offerHelpers/utils/constraintHelper';

import { InStoreOnlyFormValues } from './in-store-only-constraint.types';

export const getInStoreOnlyConstraint = (offer: OfferFragment | undefined) => {
  return offer?.constraints.find(constraintHelper.isInStoreOnly);
};

export const getInStoreOnlyInitialValues = (
  offer: OfferFragment,
): InStoreOnlyFormValues['inStoreOnlyConstraint'] => {
  const inStoreOnlyConstraint = getInStoreOnlyConstraint(offer);

  return {
    isEnabled: !!inStoreOnlyConstraint,
  };
};

export const getInStoreOnlyConstraintOperations = (
  offerId: string,
  offer: OfferFragment | undefined,
  values: InStoreOnlyFormValues,
  dirtyFields: DirtyFieldsType,
): Operation[] => {
  const operations: Operation[] = [];
  const existingConstraint = getInStoreOnlyConstraint(offer);
  const shouldBeEnabled = values.inStoreOnlyConstraint.isEnabled;
  const isDirty = isFieldDirty<InStoreOnlyFormValues>(
    dirtyFields,
    'inStoreOnlyConstraint.isEnabled',
  );

  if (!isDirty) {
    return operations;
  }

  if (existingConstraint && !shouldBeEnabled) {
    operations.push(makeDeleteOperation('constraintDelete', existingConstraint.id));
  }

  if (!existingConstraint && shouldBeEnabled) {
    operations.push(makeCreateInStoreOnlyConstraintOperation(offerId));
  }

  return operations;
};
